// Copy for the premium feature gate sheet, keyed by the English text so literals in the
// component stay readable. Look up with gateText() from shared/utils/uiText.
export const premiumGateCopy = {
  en: {
    'Unlock Premium Feature': 'Unlock Premium Feature',
    '✨ Preview Plans': '✨ Preview Plans',
    'Explore Premium': 'Explore Premium',
    '✨ View All Plans': '✨ View All Plans',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Unlock premium play for you and your household',
    'Enhanced functionality': 'Enhanced functionality',
    'Professional features': 'Professional features',
    'Priority access': 'Priority access',
    'Unlimited Daily Quizzes': 'Unlimited Daily Quizzes',
    'Ad-Free Experience': 'Ad-Free Experience',
    'Unlimited Quiz History': 'Unlimited Quiz History',
    'Multiple Question Formats': 'Multiple Question Formats',
    'Multi-Language Support': 'Multi-Language Support',
    'Create Multiplayer Rooms': 'Create Multiplayer Rooms',
    'Join Multiplayer Rooms': 'Join Multiplayer Rooms',
    'Create Game Rooms': 'Create Game Rooms',
    'Join Game Rooms': 'Join Game Rooms',
    'Family Analytics': 'Family Analytics',
    'Household Sharing': 'Household Sharing',
    'Priority Support': 'Priority Support',
    'Advanced Analytics': 'Advanced Analytics',
    'Premium Quiz Packs': 'Premium Quiz Packs',
    'Member Management': 'Member Management',
    'Unlimited Bible quiz play across every category.': 'Unlimited Bible quiz play across every category.',
    'A clean, ad-free quiz experience.': 'A clean, ad-free quiz experience.',
    'Full access to your results, progress, and quiz history.': 'Full access to your results, progress, and quiz history.',
    'Unlock every premium question format.': 'Unlock every premium question format.',
    'Study in every supported language.': 'Study in every supported language.',
    'Track household progress and celebrate growth together.': 'Track household progress and celebrate growth together.',
    'Create private quiz rooms for friends and family.': 'Create private quiz rooms for friends and family.',
    'Join private quiz rooms by invite.': 'Join private quiz rooms by invite.',
    'Host larger private game-room sessions for your household.': 'Host larger private game-room sessions for your household.',
    'Join invited game-room sessions.': 'Join invited game-room sessions.',
    'Invite up to 5 family members under your Premium plan.': 'Invite up to 5 family members under your Premium plan.',
    'Access premium quiz packs and curated content.': 'Access premium quiz packs and curated content.',
    'Priority support.': 'Priority support.',
    'Advanced analytics.': 'Advanced analytics.',
    'No daily quiz limits': 'No daily quiz limits',
    'Play as many quizzes as you want': 'Play as many quizzes as you want',
    'Access to all categories': 'Access to all categories',
    'Uninterrupted quiz gameplay': 'Uninterrupted quiz gameplay',
    'Faster loading times': 'Faster loading times',
    'Cleaner, more focused interface': 'Cleaner, more focused interface',
    'Access all your past quiz results': 'Access all your past quiz results',
    'Track your progress over time': 'Track your progress over time',
    'Review questions you got wrong': 'Review questions you got wrong',
    '5 different question types': '5 different question types',
    'Multiple choice, true/false, fill blanks': 'Multiple choice, true/false, fill blanks',
    'Ordering and reordering questions': 'Ordering and reordering questions',
    'Quiz in 10 different languages': 'Quiz in 10 different languages',
    'More languages coming soon': 'More languages coming soon',
    'Study in your preferred language': 'Study in your preferred language',
    'Create quiz rooms for friends': 'Create quiz rooms for friends',
    'Host multiplayer Bible sessions': 'Host multiplayer Bible sessions',
    'Set custom room settings': 'Set custom room settings',
    'Join any multiplayer room': 'Join any multiplayer room',
    'Participate in group Bible study': 'Participate in group Bible study',
    'Connect with other players': 'Connect with other players',
    'Create advanced game rooms': 'Create advanced game rooms',
    'Support 6+ players': 'Support 6+ players',
    'Advanced features and analytics': 'Advanced features and analytics',
    'Join family and group game rooms': 'Join family and group game rooms',
    'Participate in larger sessions': 'Participate in larger sessions',
    'Access advanced game features': 'Access advanced game features',
    'Track family member progress': 'Track family member progress',
    'Monitor learning achievements': 'Monitor learning achievements',
    'Generate family reports': 'Generate family reports',
    'Invite up to 5 family members under one Premium subscription': 'Invite up to 5 family members under one Premium subscription',
    'Manage your household in one private family hub': 'Manage your household in one private family hub',
    'Keep everyone on the same Premium plan': 'Keep everyone on the same Premium plan',
    'Priority customer support': 'Priority customer support',
    'Faster response times': 'Faster response times',
    'Dedicated support channel': 'Dedicated support channel',
    'Detailed performance analytics': 'Detailed performance analytics',
    'Advanced reporting tools': 'Advanced reporting tools',
    'Custom data insights': 'Custom data insights',
    'Exclusive quiz content': 'Exclusive quiz content',
    'Premium question sets': 'Premium question sets',
    'Expert-crafted questions': 'Expert-crafted questions',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Preview',
    'What\'s included:': 'What\'s included:',
    'What you\'ll get:': 'What you\'ll get:',
    'Benefits': 'Benefits',
  },
  fr: {
    'Unlock Premium Feature': 'Débloquez une fonction Premium',
    '✨ Preview Plans': '✨ Voir les forfaits',
    'Explore Premium': 'Découvrir Premium',
    '✨ View All Plans': '✨ Voir tous les forfaits',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Débloquez le jeu premium pour vous et votre foyer',
    'Enhanced functionality': 'Fonctionnalités améliorées',
    'Professional features': 'Fonctions professionnelles',
    'Priority access': 'Accès prioritaire',
    'Unlimited Daily Quizzes': 'Quiz quotidiens illimités',
    'Ad-Free Experience': 'Expérience sans publicité',
    'Unlimited Quiz History': 'Historique des quiz illimité',
    'Multiple Question Formats': 'Formats de questions multiples',
    'Multi-Language Support': 'Prise en charge multilingue',
    'Create Multiplayer Rooms': 'Créer des salons multijoueur',
    'Join Multiplayer Rooms': 'Rejoindre des salons multijoueur',
    'Create Game Rooms': 'Créer des salons de jeu',
    'Join Game Rooms': 'Rejoindre des salons de jeu',
    'Family Analytics': 'Analyses familiales',
    'Household Sharing': 'Partage familial',
    'Priority Support': 'Assistance prioritaire',
    'Advanced Analytics': 'Analyses avancées',
    'Premium Quiz Packs': 'Packs de quiz premium',
    'Member Management': 'Gestion des membres',
    'Unlimited Bible quiz play across every category.': 'Jouez sans limite aux quiz bibliques, dans toutes les catégories.',
    'A clean, ad-free quiz experience.': 'Une expérience de quiz claire et sans publicité.',
    'Full access to your results, progress, and quiz history.': 'Accès complet à vos résultats, à votre progression et à l\'historique des quiz.',
    'Unlock every premium question format.': 'Débloquez tous les formats de questions premium.',
    'Study in every supported language.': 'Étudiez dans toutes les langues prises en charge.',
    'Track household progress and celebrate growth together.': 'Suivez la progression du foyer et célébrez la croissance ensemble.',
    'Create private quiz rooms for friends and family.': 'Créez des salons de quiz privés pour vos amis et votre famille.',
    'Join private quiz rooms by invite.': 'Rejoignez des salons de quiz privés sur invitation.',
    'Host larger private game-room sessions for your household.': 'Organisez de plus grandes sessions de jeu privées pour votre foyer.',
    'Join invited game-room sessions.': 'Rejoignez les sessions de jeu auxquelles vous êtes invité.',
    'Invite up to 5 family members under your Premium plan.': 'Invitez jusqu\'à 5 membres de la famille avec votre forfait Premium.',
    'Access premium quiz packs and curated content.': 'Accédez aux packs de quiz premium et à du contenu sélectionné.',
    'Priority support.': 'Assistance prioritaire.',
    'Advanced analytics.': 'Analyses avancées.',
    'No daily quiz limits': 'Aucune limite quotidienne de quiz',
    'Play as many quizzes as you want': 'Jouez autant de quiz que vous le souhaitez',
    'Access to all categories': 'Accès à toutes les catégories',
    'Uninterrupted quiz gameplay': 'Des quiz sans interruption',
    'Faster loading times': 'Chargement plus rapide',
    'Cleaner, more focused interface': 'Interface plus claire et plus concentrée',
    'Access all your past quiz results': 'Accédez à tous vos résultats de quiz passés',
    'Track your progress over time': 'Suivez votre progression dans le temps',
    'Review questions you got wrong': 'Revoyez les questions auxquelles vous avez mal répondu',
    '5 different question types': '5 types de questions différents',
    'Multiple choice, true/false, fill blanks': 'Choix multiple, vrai/faux, texte à trous',
    'Ordering and reordering questions': 'Questions d\'ordre et de classement',
    'Quiz in 10 different languages': 'Des quiz en 10 langues',
    'More languages coming soon': 'D\'autres langues arrivent bientôt',
    'Study in your preferred language': 'Étudiez dans votre langue préférée',
    'Create quiz rooms for friends': 'Créez des salons de quiz pour vos amis',
    'Host multiplayer Bible sessions': 'Animez des sessions bibliques multijoueur',
    'Set custom room settings': 'Personnalisez les paramètres du salon',
    'Join any multiplayer room': 'Rejoignez n\'importe quel salon multijoueur',
    'Participate in group Bible study': 'Participez à l\'étude biblique en groupe',
    'Connect with other players': 'Échangez avec d\'autres joueurs',
    'Create advanced game rooms': 'Créez des salons de jeu avancés',
    'Support 6+ players': 'Jusqu\'à 6 joueurs ou plus',
    'Advanced features and analytics': 'Fonctions avancées et analyses',
    'Join family and group game rooms': 'Rejoignez des salons de jeu en famille et en groupe',
    'Participate in larger sessions': 'Participez à des sessions plus grandes',
    'Access advanced game features': 'Accédez aux fonctions de jeu avancées',
    'Track family member progress': 'Suivez la progression des membres de la famille',
    'Monitor learning achievements': 'Suivez les réussites d\'apprentissage',
    'Generate family reports': 'Générez des rapports familiaux',
    'Invite up to 5 family members under one Premium subscription': 'Invitez jusqu\'à 5 membres de la famille avec un seul abonnement Premium',
    'Manage your household in one private family hub': 'Gérez votre foyer dans un espace familial privé',
    'Keep everyone on the same Premium plan': 'Gardez tout le monde sur le même forfait Premium',
    'Priority customer support': 'Assistance client prioritaire',
    'Faster response times': 'Temps de réponse plus rapides',
    'Dedicated support channel': 'Canal d\'assistance dédié',
    'Detailed performance analytics': 'Analyses de performance détaillées',
    'Advanced reporting tools': 'Outils de reporting avancés',
    'Custom data insights': 'Analyses de données personnalisées',
    'Exclusive quiz content': 'Contenu de quiz exclusif',
    'Premium question sets': 'Séries de questions premium',
    'Expert-crafted questions': 'Questions conçues par des experts',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Aperçu',
    'What\'s included:': 'Ce qui est inclus :',
    'What you\'ll get:': 'Ce que vous obtenez :',
    'Benefits': 'Avantages',
  },
  es: {
    'Unlock Premium Feature': 'Desbloquea una función Premium',
    '✨ Preview Plans': '✨ Ver planes',
    'Explore Premium': 'Explorar Premium',
    '✨ View All Plans': '✨ Ver todos los planes',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Desbloquea el juego premium para ti y tu hogar',
    'Enhanced functionality': 'Funcionalidad mejorada',
    'Professional features': 'Funciones profesionales',
    'Priority access': 'Acceso prioritario',
    'Unlimited Daily Quizzes': 'Quizzes diarios ilimitados',
    'Ad-Free Experience': 'Experiencia sin anuncios',
    'Unlimited Quiz History': 'Historial de quizzes ilimitado',
    'Multiple Question Formats': 'Múltiples formatos de preguntas',
    'Multi-Language Support': 'Compatibilidad con varios idiomas',
    'Create Multiplayer Rooms': 'Crear salas multijugador',
    'Join Multiplayer Rooms': 'Unirse a salas multijugador',
    'Create Game Rooms': 'Crear salas de juego',
    'Join Game Rooms': 'Unirse a salas de juego',
    'Family Analytics': 'Analíticas familiares',
    'Household Sharing': 'Compartir en el hogar',
    'Priority Support': 'Soporte prioritario',
    'Advanced Analytics': 'Analíticas avanzadas',
    'Premium Quiz Packs': 'Paquetes de quizzes premium',
    'Member Management': 'Gestión de miembros',
    'Unlimited Bible quiz play across every category.': 'Juega quizzes bíblicos sin límite en todas las categorías.',
    'A clean, ad-free quiz experience.': 'Una experiencia de quiz limpia y sin anuncios.',
    'Full access to your results, progress, and quiz history.': 'Acceso completo a tus resultados, progreso e historial de quizzes.',
    'Unlock every premium question format.': 'Desbloquea todos los formatos de preguntas premium.',
    'Study in every supported language.': 'Estudia en todos los idiomas compatibles.',
    'Track household progress and celebrate growth together.': 'Sigue el progreso del hogar y celebren juntos el crecimiento.',
    'Create private quiz rooms for friends and family.': 'Crea salas de quiz privadas para amigos y familia.',
    'Join private quiz rooms by invite.': 'Únete a salas de quiz privadas por invitación.',
    'Host larger private game-room sessions for your household.': 'Organiza sesiones de juego privadas más grandes para tu hogar.',
    'Join invited game-room sessions.': 'Únete a las sesiones de juego a las que te inviten.',
    'Invite up to 5 family members under your Premium plan.': 'Invita hasta 5 familiares con tu plan Premium.',
    'Access premium quiz packs and curated content.': 'Accede a paquetes de quizzes premium y contenido seleccionado.',
    'Priority support.': 'Soporte prioritario.',
    'Advanced analytics.': 'Analíticas avanzadas.',
    'No daily quiz limits': 'Sin límites diarios de quizzes',
    'Play as many quizzes as you want': 'Juega todos los quizzes que quieras',
    'Access to all categories': 'Acceso a todas las categorías',
    'Uninterrupted quiz gameplay': 'Quizzes sin interrupciones',
    'Faster loading times': 'Tiempos de carga más rápidos',
    'Cleaner, more focused interface': 'Interfaz más limpia y enfocada',
    'Access all your past quiz results': 'Accede a todos tus resultados anteriores',
    'Track your progress over time': 'Sigue tu progreso con el tiempo',
    'Review questions you got wrong': 'Repasa las preguntas que fallaste',
    '5 different question types': '5 tipos de preguntas diferentes',
    'Multiple choice, true/false, fill blanks': 'Opción múltiple, verdadero/falso, completar espacios',
    'Ordering and reordering questions': 'Preguntas de ordenar y reordenar',
    'Quiz in 10 different languages': 'Quizzes en 10 idiomas',
    'More languages coming soon': 'Más idiomas próximamente',
    'Study in your preferred language': 'Estudia en tu idioma preferido',
    'Create quiz rooms for friends': 'Crea salas de quiz para amigos',
    'Host multiplayer Bible sessions': 'Organiza sesiones bíblicas multijugador',
    'Set custom room settings': 'Personaliza los ajustes de la sala',
    'Join any multiplayer room': 'Únete a cualquier sala multijugador',
    'Participate in group Bible study': 'Participa en estudios bíblicos en grupo',
    'Connect with other players': 'Conecta con otros jugadores',
    'Create advanced game rooms': 'Crea salas de juego avanzadas',
    'Support 6+ players': 'Admite 6 o más jugadores',
    'Advanced features and analytics': 'Funciones avanzadas y analíticas',
    'Join family and group game rooms': 'Únete a salas de juego familiares y de grupo',
    'Participate in larger sessions': 'Participa en sesiones más grandes',
    'Access advanced game features': 'Accede a funciones de juego avanzadas',
    'Track family member progress': 'Sigue el progreso de los miembros de la familia',
    'Monitor learning achievements': 'Monitorea los logros de aprendizaje',
    'Generate family reports': 'Genera informes familiares',
    'Invite up to 5 family members under one Premium subscription': 'Invita hasta 5 familiares con una sola suscripción Premium',
    'Manage your household in one private family hub': 'Gestiona tu hogar en un centro familiar privado',
    'Keep everyone on the same Premium plan': 'Mantén a todos en el mismo plan Premium',
    'Priority customer support': 'Atención al cliente prioritaria',
    'Faster response times': 'Tiempos de respuesta más rápidos',
    'Dedicated support channel': 'Canal de soporte dedicado',
    'Detailed performance analytics': 'Analíticas de rendimiento detalladas',
    'Advanced reporting tools': 'Herramientas de informes avanzadas',
    'Custom data insights': 'Análisis de datos personalizados',
    'Exclusive quiz content': 'Contenido de quiz exclusivo',
    'Premium question sets': 'Conjuntos de preguntas premium',
    'Expert-crafted questions': 'Preguntas elaboradas por expertos',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Vista previa',
    'What\'s included:': 'Qué incluye:',
    'What you\'ll get:': 'Lo que obtendrás:',
    'Benefits': 'Ventajas',
  },
  de: {
    'Unlock Premium Feature': 'Premium-Funktion freischalten',
    '✨ Preview Plans': '✨ Pläne ansehen',
    'Explore Premium': 'Premium entdecken',
    '✨ View All Plans': '✨ Alle Pläne ansehen',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Schalte Premium-Spielspaß für dich und deinen Haushalt frei',
    'Enhanced functionality': 'Erweiterte Funktionen',
    'Professional features': 'Professionelle Funktionen',
    'Priority access': 'Bevorzugter Zugang',
    'Unlimited Daily Quizzes': 'Unbegrenzte tägliche Quizze',
    'Ad-Free Experience': 'Werbefreies Erlebnis',
    'Unlimited Quiz History': 'Unbegrenzter Quizverlauf',
    'Multiple Question Formats': 'Mehrere Fragetypen',
    'Multi-Language Support': 'Mehrsprachige Unterstützung',
    'Create Multiplayer Rooms': 'Mehrspieler-Räume erstellen',
    'Join Multiplayer Rooms': 'Mehrspieler-Räumen beitreten',
    'Create Game Rooms': 'Spielräume erstellen',
    'Join Game Rooms': 'Spielräumen beitreten',
    'Family Analytics': 'Familien-Analysen',
    'Household Sharing': 'Haushaltsfreigabe',
    'Priority Support': 'Priorisierter Support',
    'Advanced Analytics': 'Erweiterte Analysen',
    'Premium Quiz Packs': 'Premium-Quizpakete',
    'Member Management': 'Mitgliederverwaltung',
    'Unlimited Bible quiz play across every category.': 'Unbegrenztes Bibelquiz-Spielen in allen Kategorien.',
    'A clean, ad-free quiz experience.': 'Ein klares, werbefreies Quizerlebnis.',
    'Full access to your results, progress, and quiz history.': 'Voller Zugriff auf deine Ergebnisse, deinen Fortschritt und den Quizverlauf.',
    'Unlock every premium question format.': 'Schalte alle Premium-Fragetypen frei.',
    'Study in every supported language.': 'Lerne in jeder unterstützten Sprache.',
    'Track household progress and celebrate growth together.': 'Verfolge den Fortschritt des Haushalts und feiert gemeinsam das Wachstum.',
    'Create private quiz rooms for friends and family.': 'Erstelle private Quizräume für Freunde und Familie.',
    'Join private quiz rooms by invite.': 'Tritt privaten Quizräumen per Einladung bei.',
    'Host larger private game-room sessions for your household.': 'Leite größere private Spielrunden für deinen Haushalt.',
    'Join invited game-room sessions.': 'Tritt Spielrunden bei, zu denen du eingeladen wurdest.',
    'Invite up to 5 family members under your Premium plan.': 'Lade mit deinem Premium-Plan bis zu 5 Familienmitglieder ein.',
    'Access premium quiz packs and curated content.': 'Nutze Premium-Quizpakete und ausgewählte Inhalte.',
    'Priority support.': 'Priorisierter Support.',
    'Advanced analytics.': 'Erweiterte Analysen.',
    'No daily quiz limits': 'Keine täglichen Quizlimits',
    'Play as many quizzes as you want': 'Spiele so viele Quizze, wie du möchtest',
    'Access to all categories': 'Zugriff auf alle Kategorien',
    'Uninterrupted quiz gameplay': 'Ununterbrochenes Quizspiel',
    'Faster loading times': 'Schnellere Ladezeiten',
    'Cleaner, more focused interface': 'Übersichtlichere, fokussiertere Oberfläche',
    'Access all your past quiz results': 'Greife auf alle bisherigen Quizergebnisse zu',
    'Track your progress over time': 'Verfolge deinen Fortschritt im Zeitverlauf',
    'Review questions you got wrong': 'Sieh dir Fragen an, die du falsch hattest',
    '5 different question types': '5 verschiedene Fragetypen',
    'Multiple choice, true/false, fill blanks': 'Multiple Choice, Wahr/Falsch, Lückentext',
    'Ordering and reordering questions': 'Reihenfolge- und Sortierfragen',
    'Quiz in 10 different languages': 'Quizze in 10 verschiedenen Sprachen',
    'More languages coming soon': 'Weitere Sprachen folgen bald',
    'Study in your preferred language': 'Lerne in deiner bevorzugten Sprache',
    'Create quiz rooms for friends': 'Erstelle Quizräume für Freunde',
    'Host multiplayer Bible sessions': 'Leite Bibelrunden im Mehrspielermodus',
    'Set custom room settings': 'Passe die Raumeinstellungen an',
    'Join any multiplayer room': 'Tritt jedem Mehrspieler-Raum bei',
    'Participate in group Bible study': 'Nimm an Bibelstudien in der Gruppe teil',
    'Connect with other players': 'Verbinde dich mit anderen Spielern',
    'Create advanced game rooms': 'Erstelle erweiterte Spielräume',
    'Support 6+ players': 'Unterstützt 6+ Spieler',
    'Advanced features and analytics': 'Erweiterte Funktionen und Analysen',
    'Join family and group game rooms': 'Tritt Familien- und Gruppenspielräumen bei',
    'Participate in larger sessions': 'Nimm an größeren Runden teil',
    'Access advanced game features': 'Nutze erweiterte Spielfunktionen',
    'Track family member progress': 'Verfolge den Fortschritt der Familienmitglieder',
    'Monitor learning achievements': 'Behalte Lernerfolge im Blick',
    'Generate family reports': 'Erstelle Familienberichte',
    'Invite up to 5 family members under one Premium subscription': 'Lade bis zu 5 Familienmitglieder mit einem Premium-Abo ein',
    'Manage your household in one private family hub': 'Verwalte deinen Haushalt in einem privaten Familienbereich',
    'Keep everyone on the same Premium plan': 'Halte alle auf demselben Premium-Plan',
    'Priority customer support': 'Priorisierter Kundensupport',
    'Faster response times': 'Schnellere Antwortzeiten',
    'Dedicated support channel': 'Eigener Support-Kanal',
    'Detailed performance analytics': 'Detaillierte Leistungsanalysen',
    'Advanced reporting tools': 'Erweiterte Berichtswerkzeuge',
    'Custom data insights': 'Individuelle Dateneinblicke',
    'Exclusive quiz content': 'Exklusive Quizinhalte',
    'Premium question sets': 'Premium-Fragensets',
    'Expert-crafted questions': 'Von Experten erstellte Fragen',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Vorschau',
    'What\'s included:': 'Das ist enthalten:',
    'What you\'ll get:': 'Das bekommst du:',
    'Benefits': 'Vorteile',
  },
  pt: {
    'Unlock Premium Feature': 'Desbloqueie um recurso Premium',
    '✨ Preview Plans': '✨ Ver planos',
    'Explore Premium': 'Explorar o Premium',
    '✨ View All Plans': '✨ Ver todos os planos',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Desbloqueie o jogo premium para você e sua casa',
    'Enhanced functionality': 'Funcionalidade aprimorada',
    'Professional features': 'Recursos profissionais',
    'Priority access': 'Acesso prioritário',
    'Unlimited Daily Quizzes': 'Quizzes diários ilimitados',
    'Ad-Free Experience': 'Experiência sem anúncios',
    'Unlimited Quiz History': 'Histórico de quizzes ilimitado',
    'Multiple Question Formats': 'Vários formatos de perguntas',
    'Multi-Language Support': 'Suporte a vários idiomas',
    'Create Multiplayer Rooms': 'Criar salas multijogador',
    'Join Multiplayer Rooms': 'Entrar em salas multijogador',
    'Create Game Rooms': 'Criar salas de jogo',
    'Join Game Rooms': 'Entrar em salas de jogo',
    'Family Analytics': 'Análises da família',
    'Household Sharing': 'Compartilhamento familiar',
    'Priority Support': 'Suporte prioritário',
    'Advanced Analytics': 'Análises avançadas',
    'Premium Quiz Packs': 'Pacotes de quizzes premium',
    'Member Management': 'Gerenciamento de membros',
    'Unlimited Bible quiz play across every category.': 'Jogue quizzes bíblicos sem limites em todas as categorias.',
    'A clean, ad-free quiz experience.': 'Uma experiência de quiz limpa e sem anúncios.',
    'Full access to your results, progress, and quiz history.': 'Acesso total aos seus resultados, progresso e histórico de quizzes.',
    'Unlock every premium question format.': 'Desbloqueie todos os formatos de perguntas premium.',
    'Study in every supported language.': 'Estude em todos os idiomas compatíveis.',
    'Track household progress and celebrate growth together.': 'Acompanhe o progresso da família e celebrem o crescimento juntos.',
    'Create private quiz rooms for friends and family.': 'Crie salas de quiz privadas para amigos e família.',
    'Join private quiz rooms by invite.': 'Entre em salas de quiz privadas por convite.',
    'Host larger private game-room sessions for your household.': 'Hospede sessões de jogo privadas maiores para sua família.',
    'Join invited game-room sessions.': 'Entre nas sessões de jogo para as quais foi convidado.',
    'Invite up to 5 family members under your Premium plan.': 'Convide até 5 familiares com seu plano Premium.',
    'Access premium quiz packs and curated content.': 'Acesse pacotes de quizzes premium e conteúdo selecionado.',
    'Priority support.': 'Suporte prioritário.',
    'Advanced analytics.': 'Análises avançadas.',
    'No daily quiz limits': 'Sem limites diários de quizzes',
    'Play as many quizzes as you want': 'Jogue quantos quizzes quiser',
    'Access to all categories': 'Acesso a todas as categorias',
    'Uninterrupted quiz gameplay': 'Quizzes sem interrupções',
    'Faster loading times': 'Carregamento mais rápido',
    'Cleaner, more focused interface': 'Interface mais limpa e focada',
    'Access all your past quiz results': 'Acesse todos os seus resultados anteriores',
    'Track your progress over time': 'Acompanhe seu progresso ao longo do tempo',
    'Review questions you got wrong': 'Revise as perguntas que você errou',
    '5 different question types': '5 tipos de perguntas diferentes',
    'Multiple choice, true/false, fill blanks': 'Múltipla escolha, verdadeiro/falso, completar lacunas',
    'Ordering and reordering questions': 'Perguntas de ordenar e reordenar',
    'Quiz in 10 different languages': 'Quizzes em 10 idiomas',
    'More languages coming soon': 'Mais idiomas em breve',
    'Study in your preferred language': 'Estude no seu idioma preferido',
    'Create quiz rooms for friends': 'Crie salas de quiz para amigos',
    'Host multiplayer Bible sessions': 'Conduza sessões bíblicas multijogador',
    'Set custom room settings': 'Personalize as configurações da sala',
    'Join any multiplayer room': 'Entre em qualquer sala multijogador',
    'Participate in group Bible study': 'Participe de estudos bíblicos em grupo',
    'Connect with other players': 'Conecte-se com outros jogadores',
    'Create advanced game rooms': 'Crie salas de jogo avançadas',
    'Support 6+ players': 'Suporte a 6 ou mais jogadores',
    'Advanced features and analytics': 'Recursos avançados e análises',
    'Join family and group game rooms': 'Entre em salas de jogo de família e grupo',
    'Participate in larger sessions': 'Participe de sessões maiores',
    'Access advanced game features': 'Acesse recursos de jogo avançados',
    'Track family member progress': 'Acompanhe o progresso dos membros da família',
    'Monitor learning achievements': 'Monitore as conquistas de aprendizado',
    'Generate family reports': 'Gere relatórios da família',
    'Invite up to 5 family members under one Premium subscription': 'Convide até 5 familiares com uma única assinatura Premium',
    'Manage your household in one private family hub': 'Gerencie sua família em um espaço familiar privado',
    'Keep everyone on the same Premium plan': 'Mantenha todos no mesmo plano Premium',
    'Priority customer support': 'Suporte prioritário ao cliente',
    'Faster response times': 'Tempos de resposta mais rápidos',
    'Dedicated support channel': 'Canal de suporte dedicado',
    'Detailed performance analytics': 'Análises de desempenho detalhadas',
    'Advanced reporting tools': 'Ferramentas de relatório avançadas',
    'Custom data insights': 'Insights de dados personalizados',
    'Exclusive quiz content': 'Conteúdo de quiz exclusivo',
    'Premium question sets': 'Conjuntos de perguntas premium',
    'Expert-crafted questions': 'Perguntas elaboradas por especialistas',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Prévia',
    'What\'s included:': 'O que está incluído:',
    'What you\'ll get:': 'O que você terá:',
    'Benefits': 'Benefícios',
  },
  ru: {
    'Unlock Premium Feature': 'Откройте премиум-функцию',
    '✨ Preview Plans': '✨ Посмотреть планы',
    'Explore Premium': 'Узнать о Premium',
    '✨ View All Plans': '✨ Все планы',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Откройте премиум-игру для себя и своей семьи',
    'Enhanced functionality': 'Расширенные возможности',
    'Professional features': 'Профессиональные функции',
    'Priority access': 'Приоритетный доступ',
    'Unlimited Daily Quizzes': 'Неограниченные ежедневные викторины',
    'Ad-Free Experience': 'Без рекламы',
    'Unlimited Quiz History': 'Неограниченная история викторин',
    'Multiple Question Formats': 'Разные форматы вопросов',
    'Multi-Language Support': 'Поддержка нескольких языков',
    'Create Multiplayer Rooms': 'Создание комнат для групповой игры',
    'Join Multiplayer Rooms': 'Вход в комнаты групповой игры',
    'Create Game Rooms': 'Создание игровых комнат',
    'Join Game Rooms': 'Вход в игровые комнаты',
    'Family Analytics': 'Аналитика семьи',
    'Household Sharing': 'Семейный доступ',
    'Priority Support': 'Приоритетная поддержка',
    'Advanced Analytics': 'Расширенная аналитика',
    'Premium Quiz Packs': 'Премиум-наборы викторин',
    'Member Management': 'Управление участниками',
    'Unlimited Bible quiz play across every category.': 'Неограниченные библейские викторины во всех категориях.',
    'A clean, ad-free quiz experience.': 'Чистая викторина без рекламы.',
    'Full access to your results, progress, and quiz history.': 'Полный доступ к результатам, прогрессу и истории викторин.',
    'Unlock every premium question format.': 'Откройте все премиум-форматы вопросов.',
    'Study in every supported language.': 'Изучайте на любом поддерживаемом языке.',
    'Track household progress and celebrate growth together.': 'Следите за прогрессом семьи и радуйтесь росту вместе.',
    'Create private quiz rooms for friends and family.': 'Создавайте закрытые комнаты викторин для друзей и семьи.',
    'Join private quiz rooms by invite.': 'Входите в закрытые комнаты викторин по приглашению.',
    'Host larger private game-room sessions for your household.': 'Проводите более крупные закрытые игры для вашей семьи.',
    'Join invited game-room sessions.': 'Присоединяйтесь к игровым комнатам по приглашению.',
    'Invite up to 5 family members under your Premium plan.': 'Приглашайте до 5 членов семьи по вашему плану Premium.',
    'Access premium quiz packs and curated content.': 'Получите премиум-наборы викторин и подобранный контент.',
    'Priority support.': 'Приоритетная поддержка.',
    'Advanced analytics.': 'Расширенная аналитика.',
    'No daily quiz limits': 'Без дневных ограничений на викторины',
    'Play as many quizzes as you want': 'Проходите сколько угодно викторин',
    'Access to all categories': 'Доступ ко всем категориям',
    'Uninterrupted quiz gameplay': 'Викторины без перерывов',
    'Faster loading times': 'Более быстрая загрузка',
    'Cleaner, more focused interface': 'Более чистый и сосредоточенный интерфейс',
    'Access all your past quiz results': 'Доступ ко всем прошлым результатам',
    'Track your progress over time': 'Следите за прогрессом со временем',
    'Review questions you got wrong': 'Просматривайте вопросы с ошибками',
    '5 different question types': '5 разных типов вопросов',
    'Multiple choice, true/false, fill blanks': 'Тесты, верно/неверно, пропуски',
    'Ordering and reordering questions': 'Вопросы на порядок и расстановку',
    'Quiz in 10 different languages': 'Викторины на 10 языках',
    'More languages coming soon': 'Скоро появятся новые языки',
    'Study in your preferred language': 'Изучайте на удобном языке',
    'Create quiz rooms for friends': 'Создавайте комнаты викторин для друзей',
    'Host multiplayer Bible sessions': 'Проводите групповые библейские игры',
    'Set custom room settings': 'Настраивайте параметры комнаты',
    'Join any multiplayer room': 'Входите в любую комнату групповой игры',
    'Participate in group Bible study': 'Участвуйте в групповом изучении Библии',
    'Connect with other players': 'Общайтесь с другими игроками',
    'Create advanced game rooms': 'Создавайте расширенные игровые комнаты',
    'Support 6+ players': 'Поддержка 6 и более игроков',
    'Advanced features and analytics': 'Расширенные функции и аналитика',
    'Join family and group game rooms': 'Входите в семейные и групповые игровые комнаты',
    'Participate in larger sessions': 'Участвуйте в более крупных играх',
    'Access advanced game features': 'Доступ к расширенным игровым функциям',
    'Track family member progress': 'Следите за прогрессом членов семьи',
    'Monitor learning achievements': 'Отслеживайте учебные достижения',
    'Generate family reports': 'Создавайте семейные отчёты',
    'Invite up to 5 family members under one Premium subscription': 'Приглашайте до 5 членов семьи по одной подписке Premium',
    'Manage your household in one private family hub': 'Управляйте семьёй в одном закрытом семейном разделе',
    'Keep everyone on the same Premium plan': 'Все участники на одном плане Premium',
    'Priority customer support': 'Приоритетная поддержка клиентов',
    'Faster response times': 'Более быстрые ответы',
    'Dedicated support channel': 'Отдельный канал поддержки',
    'Detailed performance analytics': 'Подробная аналитика результатов',
    'Advanced reporting tools': 'Расширенные инструменты отчётности',
    'Custom data insights': 'Индивидуальная аналитика данных',
    'Exclusive quiz content': 'Эксклюзивные викторины',
    'Premium question sets': 'Премиум-наборы вопросов',
    'Expert-crafted questions': 'Вопросы от экспертов',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Предпросмотр',
    'What\'s included:': 'Что входит:',
    'What you\'ll get:': 'Что вы получите:',
    'Benefits': 'Преимущества',
  },
  it: {
    'Unlock Premium Feature': 'Sblocca una funzione Premium',
    '✨ Preview Plans': '✨ Vedi i piani',
    'Explore Premium': 'Scopri Premium',
    '✨ View All Plans': '✨ Vedi tutti i piani',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'Sblocca il gioco premium per te e la tua famiglia',
    'Enhanced functionality': 'Funzionalità avanzate',
    'Professional features': 'Funzioni professionali',
    'Priority access': 'Accesso prioritario',
    'Unlimited Daily Quizzes': 'Quiz giornalieri illimitati',
    'Ad-Free Experience': 'Esperienza senza pubblicità',
    'Unlimited Quiz History': 'Cronologia dei quiz illimitata',
    'Multiple Question Formats': 'Più formati di domande',
    'Multi-Language Support': 'Supporto multilingue',
    'Create Multiplayer Rooms': 'Crea stanze multigiocatore',
    'Join Multiplayer Rooms': 'Unisciti a stanze multigiocatore',
    'Create Game Rooms': 'Crea stanze di gioco',
    'Join Game Rooms': 'Unisciti a stanze di gioco',
    'Family Analytics': 'Statistiche della famiglia',
    'Household Sharing': 'Condivisione familiare',
    'Priority Support': 'Assistenza prioritaria',
    'Advanced Analytics': 'Statistiche avanzate',
    'Premium Quiz Packs': 'Pacchetti di quiz premium',
    'Member Management': 'Gestione dei membri',
    'Unlimited Bible quiz play across every category.': 'Gioca ai quiz biblici senza limiti in ogni categoria.',
    'A clean, ad-free quiz experience.': 'Un\'esperienza quiz pulita e senza pubblicità.',
    'Full access to your results, progress, and quiz history.': 'Accesso completo a risultati, progressi e cronologia dei quiz.',
    'Unlock every premium question format.': 'Sblocca tutti i formati di domande premium.',
    'Study in every supported language.': 'Studia in tutte le lingue supportate.',
    'Track household progress and celebrate growth together.': 'Segui i progressi della famiglia e festeggiate la crescita insieme.',
    'Create private quiz rooms for friends and family.': 'Crea stanze quiz private per amici e famiglia.',
    'Join private quiz rooms by invite.': 'Unisciti a stanze quiz private su invito.',
    'Host larger private game-room sessions for your household.': 'Ospita sessioni di gioco private più ampie per la tua famiglia.',
    'Join invited game-room sessions.': 'Unisciti alle sessioni di gioco a cui sei invitato.',
    'Invite up to 5 family members under your Premium plan.': 'Invita fino a 5 familiari con il tuo piano Premium.',
    'Access premium quiz packs and curated content.': 'Accedi a pacchetti di quiz premium e contenuti selezionati.',
    'Priority support.': 'Assistenza prioritaria.',
    'Advanced analytics.': 'Statistiche avanzate.',
    'No daily quiz limits': 'Nessun limite giornaliero di quiz',
    'Play as many quizzes as you want': 'Gioca a tutti i quiz che vuoi',
    'Access to all categories': 'Accesso a tutte le categorie',
    'Uninterrupted quiz gameplay': 'Quiz senza interruzioni',
    'Faster loading times': 'Caricamenti più rapidi',
    'Cleaner, more focused interface': 'Interfaccia più pulita e focalizzata',
    'Access all your past quiz results': 'Accedi a tutti i risultati passati',
    'Track your progress over time': 'Segui i tuoi progressi nel tempo',
    'Review questions you got wrong': 'Rivedi le domande sbagliate',
    '5 different question types': '5 diversi tipi di domande',
    'Multiple choice, true/false, fill blanks': 'Scelta multipla, vero/falso, completamento',
    'Ordering and reordering questions': 'Domande di ordinamento e riordino',
    'Quiz in 10 different languages': 'Quiz in 10 lingue diverse',
    'More languages coming soon': 'Altre lingue in arrivo',
    'Study in your preferred language': 'Studia nella tua lingua preferita',
    'Create quiz rooms for friends': 'Crea stanze quiz per gli amici',
    'Host multiplayer Bible sessions': 'Conduci sessioni bibliche multigiocatore',
    'Set custom room settings': 'Personalizza le impostazioni della stanza',
    'Join any multiplayer room': 'Unisciti a qualsiasi stanza multigiocatore',
    'Participate in group Bible study': 'Partecipa allo studio biblico di gruppo',
    'Connect with other players': 'Entra in contatto con altri giocatori',
    'Create advanced game rooms': 'Crea stanze di gioco avanzate',
    'Support 6+ players': 'Supporta 6 o più giocatori',
    'Advanced features and analytics': 'Funzioni avanzate e statistiche',
    'Join family and group game rooms': 'Unisciti a stanze di gioco di famiglia e di gruppo',
    'Participate in larger sessions': 'Partecipa a sessioni più ampie',
    'Access advanced game features': 'Accedi alle funzioni di gioco avanzate',
    'Track family member progress': 'Segui i progressi dei familiari',
    'Monitor learning achievements': 'Monitora i traguardi di apprendimento',
    'Generate family reports': 'Genera report familiari',
    'Invite up to 5 family members under one Premium subscription': 'Invita fino a 5 familiari con un solo abbonamento Premium',
    'Manage your household in one private family hub': 'Gestisci la tua famiglia in un hub familiare privato',
    'Keep everyone on the same Premium plan': 'Mantieni tutti sullo stesso piano Premium',
    'Priority customer support': 'Assistenza clienti prioritaria',
    'Faster response times': 'Tempi di risposta più rapidi',
    'Dedicated support channel': 'Canale di assistenza dedicato',
    'Detailed performance analytics': 'Statistiche dettagliate sul rendimento',
    'Advanced reporting tools': 'Strumenti di reportistica avanzati',
    'Custom data insights': 'Approfondimenti dati personalizzati',
    'Exclusive quiz content': 'Contenuti quiz esclusivi',
    'Premium question sets': 'Set di domande premium',
    'Expert-crafted questions': 'Domande create da esperti',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Anteprima',
    'What\'s included:': 'Cosa è incluso:',
    'What you\'ll get:': 'Cosa otterrai:',
    'Benefits': 'Vantaggi',
  },
  ko: {
    'Unlock Premium Feature': '프리미엄 기능 잠금 해제',
    '✨ Preview Plans': '✨ 플랜 미리보기',
    'Explore Premium': '프리미엄 살펴보기',
    '✨ View All Plans': '✨ 모든 플랜 보기',
    '✨ PREMIUM': '✨ 프리미엄',
    'Unlock premium play for you and your household': '나와 우리 가족을 위한 프리미엄 플레이를 열어 보세요',
    'Enhanced functionality': '향상된 기능',
    'Professional features': '전문 기능',
    'Priority access': '우선 이용',
    'Unlimited Daily Quizzes': '매일 무제한 퀴즈',
    'Ad-Free Experience': '광고 없는 환경',
    'Unlimited Quiz History': '무제한 퀴즈 기록',
    'Multiple Question Formats': '다양한 문제 유형',
    'Multi-Language Support': '다국어 지원',
    'Create Multiplayer Rooms': '멀티플레이 방 만들기',
    'Join Multiplayer Rooms': '멀티플레이 방 참여하기',
    'Create Game Rooms': '게임 방 만들기',
    'Join Game Rooms': '게임 방 참여하기',
    'Family Analytics': '가족 분석',
    'Household Sharing': '가족 공유',
    'Priority Support': '우선 지원',
    'Advanced Analytics': '고급 분석',
    'Premium Quiz Packs': '프리미엄 퀴즈 팩',
    'Member Management': '멤버 관리',
    'Unlimited Bible quiz play across every category.': '모든 카테고리에서 성경 퀴즈를 무제한으로 즐기세요.',
    'A clean, ad-free quiz experience.': '깔끔하고 광고 없는 퀴즈 환경.',
    'Full access to your results, progress, and quiz history.': '결과, 진행 상황, 퀴즈 기록을 모두 확인하세요.',
    'Unlock every premium question format.': '모든 프리미엄 문제 유형을 잠금 해제하세요.',
    'Study in every supported language.': '지원되는 모든 언어로 공부하세요.',
    'Track household progress and celebrate growth together.': '가족의 진행 상황을 확인하고 함께 성장을 기뻐하세요.',
    'Create private quiz rooms for friends and family.': '친구·가족과 함께하는 비공개 퀴즈 방을 만드세요.',
    'Join private quiz rooms by invite.': '초대를 받아 비공개 퀴즈 방에 참여하세요.',
    'Host larger private game-room sessions for your household.': '가족을 위한 더 큰 비공개 게임 방을 진행하세요.',
    'Join invited game-room sessions.': '초대받은 게임 방 세션에 참여하세요.',
    'Invite up to 5 family members under your Premium plan.': '프리미엄 플랜으로 가족 최대 5명을 초대하세요.',
    'Access premium quiz packs and curated content.': '프리미엄 퀴즈 팩과 엄선된 콘텐츠를 이용하세요.',
    'Priority support.': '우선 지원.',
    'Advanced analytics.': '고급 분석.',
    'No daily quiz limits': '하루 퀴즈 제한 없음',
    'Play as many quizzes as you want': '원하는 만큼 퀴즈를 즐기세요',
    'Access to all categories': '모든 카테고리 이용',
    'Uninterrupted quiz gameplay': '끊김 없는 퀴즈 플레이',
    'Faster loading times': '더 빠른 로딩',
    'Cleaner, more focused interface': '더 깔끔하고 집중하기 좋은 화면',
    'Access all your past quiz results': '지난 퀴즈 결과 모두 보기',
    'Track your progress over time': '시간에 따른 진행 상황 확인',
    'Review questions you got wrong': '틀린 문제 복습하기',
    '5 different question types': '5가지 문제 유형',
    'Multiple choice, true/false, fill blanks': '객관식, O/X, 빈칸 채우기',
    'Ordering and reordering questions': '순서 맞추기 문제',
    'Quiz in 10 different languages': '10개 언어로 퀴즈 즐기기',
    'More languages coming soon': '더 많은 언어가 곧 추가됩니다',
    'Study in your preferred language': '원하는 언어로 공부하기',
    'Create quiz rooms for friends': '친구를 위한 퀴즈 방 만들기',
    'Host multiplayer Bible sessions': '멀티플레이 성경 모임 진행하기',
    'Set custom room settings': '방 설정 맞춤 지정',
    'Join any multiplayer room': '모든 멀티플레이 방에 참여',
    'Participate in group Bible study': '그룹 성경 공부에 참여',
    'Connect with other players': '다른 플레이어와 만나기',
    'Create advanced game rooms': '고급 게임 방 만들기',
    'Support 6+ players': '6명 이상 지원',
    'Advanced features and analytics': '고급 기능과 분석',
    'Join family and group game rooms': '가족 및 그룹 게임 방 참여',
    'Participate in larger sessions': '더 큰 세션에 참여',
    'Access advanced game features': '고급 게임 기능 이용',
    'Track family member progress': '가족 구성원의 진행 상황 확인',
    'Monitor learning achievements': '학습 성과 확인',
    'Generate family reports': '가족 보고서 만들기',
    'Invite up to 5 family members under one Premium subscription': '프리미엄 구독 하나로 가족 최대 5명 초대',
    'Manage your household in one private family hub': '하나의 비공개 가족 허브에서 가족 관리',
    'Keep everyone on the same Premium plan': '모두 같은 프리미엄 플랜으로 이용',
    'Priority customer support': '우선 고객 지원',
    'Faster response times': '더 빠른 응답',
    'Dedicated support channel': '전용 지원 채널',
    'Detailed performance analytics': '상세한 성과 분석',
    'Advanced reporting tools': '고급 보고 도구',
    'Custom data insights': '맞춤 데이터 인사이트',
    'Exclusive quiz content': '독점 퀴즈 콘텐츠',
    'Premium question sets': '프리미엄 문제 세트',
    'Expert-crafted questions': '전문가가 만든 문제',
    'PREMIUM': '프리미엄',
    'Preview': '미리보기',
    'What\'s included:': '포함된 내용:',
    'What you\'ll get:': '이용할 수 있는 혜택:',
    'Benefits': '혜택',
  },
  tl: {
    'Unlock Premium Feature': 'I-unlock ang Premium na Feature',
    '✨ Preview Plans': '✨ Tingnan ang mga Plan',
    'Explore Premium': 'Tuklasin ang Premium',
    '✨ View All Plans': '✨ Tingnan ang Lahat ng Plan',
    '✨ PREMIUM': '✨ PREMIUM',
    'Unlock premium play for you and your household': 'I-unlock ang premium na laro para sa iyo at sa iyong sambahayan',
    'Enhanced functionality': 'Pinahusay na functionality',
    'Professional features': 'Mga propesyonal na feature',
    'Priority access': 'Priyoridad na access',
    'Unlimited Daily Quizzes': 'Walang Limitasyong Pang-araw-araw na Quiz',
    'Ad-Free Experience': 'Karanasang Walang Ad',
    'Unlimited Quiz History': 'Walang Limitasyong Kasaysayan ng Quiz',
    'Multiple Question Formats': 'Maraming Format ng Tanong',
    'Multi-Language Support': 'Suporta sa Maraming Wika',
    'Create Multiplayer Rooms': 'Gumawa ng Multiplayer Room',
    'Join Multiplayer Rooms': 'Sumali sa Multiplayer Room',
    'Create Game Rooms': 'Gumawa ng Game Room',
    'Join Game Rooms': 'Sumali sa Game Room',
    'Family Analytics': 'Analytics ng Pamilya',
    'Household Sharing': 'Pagbabahagi sa Sambahayan',
    'Priority Support': 'Priyoridad na Suporta',
    'Advanced Analytics': 'Advanced na Analytics',
    'Premium Quiz Packs': 'Premium na Quiz Pack',
    'Member Management': 'Pamamahala ng Miyembro',
    'Unlimited Bible quiz play across every category.': 'Walang limitasyong paglalaro ng Bible quiz sa bawat kategorya.',
    'A clean, ad-free quiz experience.': 'Malinis at walang ad na karanasan sa quiz.',
    'Full access to your results, progress, and quiz history.': 'Buong access sa iyong mga resulta, progreso, at kasaysayan ng quiz.',
    'Unlock every premium question format.': 'I-unlock ang bawat premium na format ng tanong.',
    'Study in every supported language.': 'Mag-aral sa bawat sinusuportahang wika.',
    'Track household progress and celebrate growth together.': 'Subaybayan ang progreso ng sambahayan at magdiwang ng paglago nang sama-sama.',
    'Create private quiz rooms for friends and family.': 'Gumawa ng pribadong quiz room para sa mga kaibigan at pamilya.',
    'Join private quiz rooms by invite.': 'Sumali sa pribadong quiz room sa pamamagitan ng imbitasyon.',
    'Host larger private game-room sessions for your household.': 'Mag-host ng mas malalaking pribadong game-room session para sa iyong sambahayan.',
    'Join invited game-room sessions.': 'Sumali sa mga game-room session kung imbitado ka.',
    'Invite up to 5 family members under your Premium plan.': 'Mag-imbita ng hanggang 5 miyembro ng pamilya sa iyong Premium plan.',
    'Access premium quiz packs and curated content.': 'Mag-access ng mga premium na quiz pack at piniling nilalaman.',
    'Priority support.': 'Priyoridad na suporta.',
    'Advanced analytics.': 'Advanced na analytics.',
    'No daily quiz limits': 'Walang pang-araw-araw na limitasyon sa quiz',
    'Play as many quizzes as you want': 'Maglaro ng kahit ilang quiz',
    'Access to all categories': 'Access sa lahat ng kategorya',
    'Uninterrupted quiz gameplay': 'Tuloy-tuloy na paglalaro ng quiz',
    'Faster loading times': 'Mas mabilis na pag-load',
    'Cleaner, more focused interface': 'Mas malinis at nakatuong interface',
    'Access all your past quiz results': 'I-access ang lahat ng nakaraang resulta ng quiz',
    'Track your progress over time': 'Subaybayan ang iyong progreso sa paglipas ng panahon',
    'Review questions you got wrong': 'Suriin ang mga tanong na nagkamali ka',
    '5 different question types': '5 magkakaibang uri ng tanong',
    'Multiple choice, true/false, fill blanks': 'Multiple choice, tama/mali, punan ang patlang',
    'Ordering and reordering questions': 'Mga tanong sa pagsunud-sunod at pag-aayos',
    'Quiz in 10 different languages': 'Quiz sa 10 magkakaibang wika',
    'More languages coming soon': 'Marami pang wika sa lalong madaling panahon',
    'Study in your preferred language': 'Mag-aral sa gusto mong wika',
    'Create quiz rooms for friends': 'Gumawa ng quiz room para sa mga kaibigan',
    'Host multiplayer Bible sessions': 'Mag-host ng multiplayer na Bible session',
    'Set custom room settings': 'Magtakda ng custom na setting ng kuwarto',
    'Join any multiplayer room': 'Sumali sa anumang multiplayer room',
    'Participate in group Bible study': 'Makilahok sa group Bible study',
    'Connect with other players': 'Makipag-ugnayan sa ibang manlalaro',
    'Create advanced game rooms': 'Gumawa ng mga advanced na game room',
    'Support 6+ players': 'Suporta ang 6+ manlalaro',
    'Advanced features and analytics': 'Mga advanced na feature at analytics',
    'Join family and group game rooms': 'Sumali sa mga game room ng pamilya at grupo',
    'Participate in larger sessions': 'Makilahok sa mas malalaking session',
    'Access advanced game features': 'Mag-access ng mga advanced na feature ng laro',
    'Track family member progress': 'Subaybayan ang progreso ng mga miyembro ng pamilya',
    'Monitor learning achievements': 'Subaybayan ang mga natamo sa pag-aaral',
    'Generate family reports': 'Gumawa ng mga ulat ng pamilya',
    'Invite up to 5 family members under one Premium subscription': 'Mag-imbita ng hanggang 5 miyembro ng pamilya sa isang Premium subscription',
    'Manage your household in one private family hub': 'Pamahalaan ang iyong sambahayan sa isang pribadong family hub',
    'Keep everyone on the same Premium plan': 'Panatilihin ang lahat sa parehong Premium plan',
    'Priority customer support': 'Priyoridad na suporta sa customer',
    'Faster response times': 'Mas mabilis na pagtugon',
    'Dedicated support channel': 'Nakalaang channel ng suporta',
    'Detailed performance analytics': 'Detalyadong analytics ng pagganap',
    'Advanced reporting tools': 'Mga advanced na tool sa pag-uulat',
    'Custom data insights': 'Custom na pananaw sa data',
    'Exclusive quiz content': 'Eksklusibong nilalaman ng quiz',
    'Premium question sets': 'Mga premium na set ng tanong',
    'Expert-crafted questions': 'Mga tanong na gawa ng eksperto',
    'PREMIUM': 'PREMIUM',
    'Preview': 'Preview',
    'What\'s included:': 'Ano ang kasama:',
    'What you\'ll get:': 'Ang makukuha mo:',
    'Benefits': 'Mga Benepisyo',
  },
  am: {
    'Unlock Premium Feature': 'የፕሪሚየም ባህሪ ይክፈቱ',
    '✨ Preview Plans': '✨ ዕቅዶችን ይመልከቱ',
    'Explore Premium': 'ፕሪሚየምን ያስሱ',
    '✨ View All Plans': '✨ ሁሉንም ዕቅዶች ይመልከቱ',
    '✨ PREMIUM': '✨ ፕሪሚየም',
    'Unlock premium play for you and your household': 'ለእርስዎና ለቤተሰብዎ ፕሪሚየም ጨዋታ ይክፈቱ',
    'Enhanced functionality': 'የተሻሻለ ተግባር',
    'Professional features': 'ሙያዊ ባህሪያት',
    'Priority access': 'ቅድሚያ መዳረሻ',
    'Unlimited Daily Quizzes': 'ያልተገደበ ዕለታዊ ጥያቄዎች',
    'Ad-Free Experience': 'ከማስታወቂያ ነፃ ተሞክሮ',
    'Unlimited Quiz History': 'ያልተገደበ የጥያቄ ታሪክ',
    'Multiple Question Formats': 'ብዙ የጥያቄ ዓይነቶች',
    'Multi-Language Support': 'ብዙ ቋንቋ ድጋፍ',
    'Create Multiplayer Rooms': 'የብዙ ተጫዋች ክፍሎችን ፍጠር',
    'Join Multiplayer Rooms': 'ወደ ብዙ ተጫዋች ክፍሎች ተቀላቀል',
    'Create Game Rooms': 'የጨዋታ ክፍሎችን ፍጠር',
    'Join Game Rooms': 'ወደ ጨዋታ ክፍሎች ተቀላቀል',
    'Family Analytics': 'የቤተሰብ ትንታኔ',
    'Household Sharing': 'የቤተሰብ መጋራት',
    'Priority Support': 'ቅድሚያ ድጋፍ',
    'Advanced Analytics': 'የላቀ ትንታኔ',
    'Premium Quiz Packs': 'ፕሪሚየም የጥያቄ ጥቅሎች',
    'Member Management': 'የአባላት አስተዳደር',
    'Unlimited Bible quiz play across every category.': 'በሁሉም ምድቦች ያልተገደበ የመጽሐፍ ቅዱስ ጥያቄ ጨዋታ።',
    'A clean, ad-free quiz experience.': 'ንጹህና ከማስታወቂያ ነፃ የጥያቄ ተሞክሮ።',
    'Full access to your results, progress, and quiz history.': 'ለውጤቶችዎ፣ እድገትዎና የጥያቄ ታሪክዎ ሙሉ መዳረሻ።',
    'Unlock every premium question format.': 'ሁሉንም የፕሪሚየም የጥያቄ ዓይነቶች ይክፈቱ።',
    'Study in every supported language.': 'በሚደገፍ ማንኛውም ቋንቋ ይማሩ።',
    'Track household progress and celebrate growth together.': 'የቤተሰብ እድገትን ይከታተሉና እድገትን በጋራ ያክብሩ።',
    'Create private quiz rooms for friends and family.': 'ለጓደኞችና ለቤተሰብ የግል የጥያቄ ክፍሎችን ይፍጠሩ።',
    'Join private quiz rooms by invite.': 'በግብዣ የግል የጥያቄ ክፍሎችን ይቀላቀሉ።',
    'Host larger private game-room sessions for your household.': 'ለቤተሰብዎ ትላልቅ የግል የጨዋታ ክፍል ክፍለ ጊዜዎችን ያስተናግዱ።',
    'Join invited game-room sessions.': 'በተጋበዙባቸው የጨዋታ ክፍል ክፍለ ጊዜዎች ይቀላቀሉ።',
    'Invite up to 5 family members under your Premium plan.': 'በፕሪሚየም ዕቅድዎ እስከ 5 የቤተሰብ አባላትን ይጋብዙ።',
    'Access premium quiz packs and curated content.': 'ፕሪሚየም የጥያቄ ጥቅሎችንና የተመረጡ ይዘቶችን ያግኙ።',
    'Priority support.': 'ቅድሚያ ድጋፍ።',
    'Advanced analytics.': 'የላቀ ትንታኔ።',
    'No daily quiz limits': 'ዕለታዊ የጥያቄ ገደብ የለም',
    'Play as many quizzes as you want': 'የፈለጉትን ያህል ጥያቄ ይጫወቱ',
    'Access to all categories': 'ወደ ሁሉም ምድቦች መዳረሻ',
    'Uninterrupted quiz gameplay': 'ያልተቋረጠ የጥያቄ ጨዋታ',
    'Faster loading times': 'ፈጣን የመጫን ጊዜ',
    'Cleaner, more focused interface': 'ይበልጥ ንጹህና ትኩረት ያለው በይነገጽ',
    'Access all your past quiz results': 'ሁሉንም ያለፉ የጥያቄ ውጤቶችዎን ይመልከቱ',
    'Track your progress over time': 'እድገትዎን በጊዜ ሂደት ይከታተሉ',
    'Review questions you got wrong': 'የተሳሳቱባቸውን ጥያቄዎች ይከልሱ',
    '5 different question types': '5 የተለያዩ የጥያቄ ዓይነቶች',
    'Multiple choice, true/false, fill blanks': 'ምርጫ፣ እውነት/ሐሰት፣ ባዶ ሙላ',
    'Ordering and reordering questions': 'የማደራጀትና እንደገና የማስተካከል ጥያቄዎች',
    'Quiz in 10 different languages': 'በ10 የተለያዩ ቋንቋዎች ጥያቄዎች',
    'More languages coming soon': 'ተጨማሪ ቋንቋዎች በቅርቡ',
    'Study in your preferred language': 'በሚመርጡት ቋንቋ ይማሩ',
    'Create quiz rooms for friends': 'ለጓደኞች የጥያቄ ክፍሎችን ይፍጠሩ',
    'Host multiplayer Bible sessions': 'የብዙ ተጫዋች የመጽሐፍ ቅዱስ ክፍለ ጊዜዎችን ያስተናግዱ',
    'Set custom room settings': 'የክፍል ቅንብሮችን ያበጁ',
    'Join any multiplayer room': 'ወደ ማንኛውም ብዙ ተጫዋች ክፍል ይቀላቀሉ',
    'Participate in group Bible study': 'በቡድን የመጽሐፍ ቅዱስ ጥናት ይሳተፉ',
    'Connect with other players': 'ከሌሎች ተጫዋቾች ጋር ይገናኙ',
    'Create advanced game rooms': 'የላቁ የጨዋታ ክፍሎችን ይፍጠሩ',
    'Support 6+ players': 'ከ6 በላይ ተጫዋቾችን ይደግፋል',
    'Advanced features and analytics': 'የላቁ ባህሪያትና ትንታኔ',
    'Join family and group game rooms': 'ወደ ቤተሰብና ቡድን የጨዋታ ክፍሎች ይቀላቀሉ',
    'Participate in larger sessions': 'በትላልቅ ክፍለ ጊዜዎች ይሳተፉ',
    'Access advanced game features': 'የላቁ የጨዋታ ባህሪያትን ያግኙ',
    'Track family member progress': 'የቤተሰብ አባላትን እድገት ይከታተሉ',
    'Monitor learning achievements': 'የትምህርት ስኬቶችን ይቆጣጠሩ',
    'Generate family reports': 'የቤተሰብ ሪፖርቶችን ይፍጠሩ',
    'Invite up to 5 family members under one Premium subscription': 'በአንድ የፕሪሚየም ምዝገባ እስከ 5 የቤተሰብ አባላትን ይጋብዙ',
    'Manage your household in one private family hub': 'ቤተሰብዎን በአንድ የግል የቤተሰብ ማዕከል ያስተዳድሩ',
    'Keep everyone on the same Premium plan': 'ሁሉንም በአንድ የፕሪሚየም ዕቅድ ያቆዩ',
    'Priority customer support': 'ቅድሚያ የደንበኛ ድጋፍ',
    'Faster response times': 'ፈጣን የምላሽ ጊዜ',
    'Dedicated support channel': 'የተለየ የድጋፍ ቻናል',
    'Detailed performance analytics': 'ዝርዝር የአፈጻጸም ትንታኔ',
    'Advanced reporting tools': 'የላቁ የሪፖርት መሳሪያዎች',
    'Custom data insights': 'ብጁ የመረጃ ማስተዋሎች',
    'Exclusive quiz content': 'ልዩ የጥያቄ ይዘት',
    'Premium question sets': 'ፕሪሚየም የጥያቄ ስብስቦች',
    'Expert-crafted questions': 'በባለሙያዎች የተዘጋጁ ጥያቄዎች',
    'PREMIUM': 'ፕሪሚየም',
    'Preview': 'ቅድመ እይታ',
    'What\'s included:': 'ምን ተካትቷል፦',
    'What you\'ll get:': 'የሚያገኙት፦',
    'Benefits': 'ጥቅሞች',
  },
};
